import React, { useState } from "react";
import { Button } from "@heroui/react";
import { Copy, Check } from "lucide-react";

interface CopyButtonProps {
  text: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export const CopyButton: React.FC<CopyButtonProps> = ({
  text,
  size = "sm",
  className = "",
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);

      // Reset the feedback after 2 seconds
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (error) {
      console.error("Failed to copy text:", error);
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand("copy");
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 2000);
      } catch (fallbackError) {
        console.error("Fallback copy failed:", fallbackError);
      }

      document.body.removeChild(textArea);
    }
  };

  return (
    <Button
      isIconOnly
      size={size}
      variant="light"
      className={`text-gray-400 hover:text-white transition-colors bg-transparent border-0 ${
        copied ? "text-white" : ""
      } ${className}`}
      onPress={handleCopy}
    >
      {copied ? <Check size={12} /> : <Copy size={12} />}
    </Button>
  );
};
